var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hmi-button",style:({
    background: _vm.color,
    width: typeof _vm.width === 'number' ? _vm.width + 'px' : _vm.width,
    height: typeof _vm.height === 'number' ? _vm.height + 'px' : _vm.height,
    border: _vm.border,
  })},[(_vm.icon)?_c('v-icon',{staticClass:"icon",style:({ color: _vm.fontColor })},[_vm._v(_vm._s(_vm.icon))]):_vm._e(),_c('v-label',{staticClass:"label",style:({ color: _vm.fontColor })},[_vm._v(_vm._s(_vm.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }